import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { paymentClient, Server } from '@wajeez-web/core/api-base';

export const getProducts: ApiMethod<void, Server.ProductOutput[]> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.products_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductsDatatable: ApiMethod<
  Server.GetProductsDatatableInput,
  Server.TableOfProductsColumns
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.admin_Products_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createProduct: ApiMethod<
  Server.CreateProductInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.products_post_V1({ ...data, languageId: 1 });

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editProduct: ApiMethod<Server.EditProductInput, number> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.products_put_V1({ ...data, languageId: 1 });

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductById: ApiMethod<
  number,
  Server.ProductGroupProductOutput
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.products_byId_get_V1(undefined, id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getProductsByProductGroupId: ApiMethod<
  number,
  Server.ProductOutput[]
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Products_Client(undefined, paymentClient);

    const response = await client.products_getByGroup_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
